<template>
  <div class="explain-mask" v-if="confirmVisible">
    <div class="explain-main">
      <div class="icon-box">
        <div class="icon-border">
          <span class="explain-icon">
            <img src="./img/1.png" alt="" width="25px" />
          </span>
        </div>
      </div>
      <p class="explain-title">说明</p>
      <div class="explain-text">
        <p>
          本平台为<span class="red-text">“Demo”（演示）</span
          >版本。上海图书馆历史人文大数据平台
        </p>
        <p>旨在利用数字人文方法和技术将其馆藏历史人文资源整合起来，实</p>
        <p>现资源、数据、知识的统一管理和服务，支持数字人文的典型研究</p>
        <p>范式和应用场景。当前版本基于上述长期目标进行了初步的探索。</p>
      </div>
      <div class="explain-btn-box">
        <a-button @click="hideModal" class="explain-btn"> 我知道了 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirmVisible: {
      required: false,
    },
  },
  methods: {
    hideModal() {
      this.$emit("ok");
    },
  },
};
</script>

<style scoped lang="less">
.explain-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 8888;
}
.explain-main {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 595px;
  height: 372px;
  margin-top: -193px;
  margin-left: -297px;
  padding: 20px;
  background: #fff;
  opacity: 0.88;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 10px 22px rgba(0, 0, 0, 0.16);
  border-radius: 13px;
  text-align: center;

  .icon-box {
    width: 100%;
    height: 60px;
    line-height: 60px;

    .icon-border {
      width: 53px;
      height: 52px;
      display: inline-block;
      line-height: 48px;
      background: rgba(242, 153, 74, 0.3);
      border-radius: 60px;

      .explain-icon {
        width: 44px;
        height: 44px;
        line-height: 40px;
        background: #f2994a;
        border-radius: 60px;
        display: inline-block;
      }
    }
  }
  .explain-title {
    font-size: 24px;
    font-weight: bold;
    color: #262626;
    text-align: center;
    margin: 24px 0;
  }
  .explain-text {
    font-size: 16px;
    font-weight: bold;
    line-height: 25px;
    color: #333;

    p {
      margin-bottom: 2px;
      letter-spacing: 2px;

      .red-text {
        font-weight: bold;
        color: #eb5757;
      }
    }
  }
  .explain-btn-box {
    text-align: center;
    margin-top: 24px;

    .explain-btn {
      width: 179px;
      height: 52px;
      background: #eb5757;
      border-radius: 5px;
      border: 0;
      font-size: 18px;
      color: #fff;
    }
  }
}
@media screen and (max-width: 1024px) {
  .explain-main {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80vw;
    height: 372px;
    margin-top: -193px;
    margin-left: -40vw;
    z-index: 9999;
    padding: 3vw;

    .explain-title {
        font-size: 18px;
        font-weight: bold;
        color: #262626;
        text-align: center;
        margin: 24px 0;
    }
    .explain-text {
      text-align: justify;
      font-size: 10px;
      p {
        display: inline;

        .red-text {
            font-weight: bold;
            color: #eb5757;
        }
        }
    }
    .explain-btn-box {
      text-align: center;
      margin-top: 24px;

      .explain-btn {
        width: 100px;
        height: 30px;
        background: #eb5757;
        border-radius: 5px;
        border: 0;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
</style>